// extracted by mini-css-extract-plugin
module.exports = {"holder":"virtualKeypad_holder__2qvqA","stationButtons":"virtualKeypad_stationButtons__3WqbW"};